import { Box, Tooltip } from '@mui/material';
import { ProgressNoteItem } from '../../services/configApi/employees/employeeServices';
import { FC } from 'react';
import MediumTypography from '../../components/formlib/MediumTypography';
import { getStatusColor } from '../../utils/utilities';
import { useNavigate } from 'react-router-dom';
import { PROGRESS_NOTE_SETUP } from '../../routes/Routing';
import { STORAGE_USERNAME_KEY } from '../../services/Constant';
import { checkPermissionForFeature } from '../../utils/checkPermission';
import { ReactComponent as ArrowRight } from '../../assets/images/right.svg';
import { formatName } from '../../utils/nameUtils';

interface ProgressNoteProps {
  progressNotes: ProgressNoteItem[];
  handleNavigation: () => void;
}

const ProgressNoteRow: FC<{
  progressNote: ProgressNoteItem;
  index: number;
}> = ({ progressNote, index }) => {
  const navigate = useNavigate();

  return (
    <Box>
      {index !== 0 && <Box className={'defaultHorizontalLine'} />}
      <Box className={'flex__'}>
        <Box sx={{ flex: 0.4 }}>
          <Tooltip
            title={
              formatName(
                progressNote.firstName,
                progressNote.middleName,
                progressNote.lastName,
                progressNote.suffix,
              ) &&
              formatName(
                progressNote.firstName,
                progressNote.middleName,
                progressNote.lastName,
                progressNote.suffix,
              ).length > 50
                ? formatName(
                    progressNote.firstName,
                    progressNote.middleName,
                    progressNote.lastName,
                    progressNote.suffix,
                  )
                : ''
            }
            followCursor
            arrow={true}
            sx={{ maxWidth: 'min-content' }}
          >
            <Box>
              <MediumTypography
                onClick={() => {
                  const userId = localStorage.getItem(STORAGE_USERNAME_KEY);
                  if (
                    userId === null &&
                    progressNote.commonAppointmentId === null
                  ) {
                    return;
                  }
                  if (
                    checkPermissionForFeature(
                      'backend.progress_note',
                      'viewPermission',
                    )
                  ) {
                    navigate(PROGRESS_NOTE_SETUP, {
                      state: {
                        sortRequired: true,
                        eventId: progressNote.commonAppointmentId,
                        attendeeId: [userId],
                        clientIds: [progressNote.clientId],
                      },
                    });
                  }
                }}
                sxProps={{
                  color: '#008C82',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                }}
                label={formatName(
                  progressNote.firstName,
                  progressNote.middleName,
                  progressNote.lastName,
                  progressNote.suffix,
                )}
              />
            </Box>
          </Tooltip>
        </Box>
        <Box className={'flex__'} sx={{ flex: 0.4 }}>
          <MediumTypography
            label={
              progressNote.dphId !== null && progressNote.dphId !== ''
                ? progressNote.dphId
                : '-'
            }
          />
        </Box>
        <Box sx={{ flex: 0.2 }}>
          <MediumTypography
            sxProps={{
              color: getStatusColor(progressNote.status),
            }}
            label={progressNote.status !== null ? progressNote.status : '-'}
          />
        </Box>
      </Box>
    </Box>
  );
};

const DashboardProgressNote: FC<ProgressNoteProps> = ({
  progressNotes,
  handleNavigation,
}) => {
  return (
    <Box className={'p-md'}>
      <Box className={'flex__ pt-xm'}>
        <MediumTypography
          sxProps={{ flexGrow: 1 }}
          className="mainText-lg"
          labelid="ProgressNote.Title"
          defaultlabel="Progress Note"
        />
        <Box sx={{ cursor: 'pointer' }} onClick={handleNavigation}>
          <ArrowRight />
        </Box>
      </Box>
      <Box
        className={'pt-md'}
        sx={{
          overflowY: 'scroll',
          height: '195px',
        }}
      >
        {progressNotes.length === 0 ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '8%',
            }}
          >
            <MediumTypography
              sxProps={{ fontWeight: 'bold' }}
              labelid="noProgressFoundText"
              defaultlabel="No Progress Notes found yet"
            />
          </Box>
        ) : (
          <Box className={'flex__ mb-sm'}>
            <MediumTypography
              sxProps={{
                color: 'var(--thom-mono-gray)',
                fontWeight: 'bold',
                flex: 0.4,
              }}
              labelid="Dashboard.ClientName"
              defaultlabel="Client Name"
            />
            <MediumTypography
              sxProps={{
                color: 'var(--thom-mono-gray)',
                fontWeight: 'bold',
                flex: 0.4,
              }}
              labelid="Facesheet.DPHID"
              defaultlabel="Enrollment ID"
            />
            <Box sx={{ flex: 0.2 }}>
              <MediumTypography
                sxProps={{
                  color: 'var(--thom-mono-gray)',
                  fontWeight: 'bold',
                }}
                labelid="Dashboard.Status"
                defaultlabel="Status"
              />
            </Box>
          </Box>
        )}

        {progressNotes.map((progressNote, index) => (
          <ProgressNoteRow
            progressNote={progressNote}
            index={index}
            key={`progressNote-${index}`}
          />
        ))}
      </Box>
    </Box>
  );
};

export default DashboardProgressNote;
